export enum SizeDropdownOptions {
  ORIGINAL = 'original',
  ORIGINAL_COMPRESSED = 'original_compressed',
  SMALL = 'small',
  LARGE = 'large',
  CUSTOM = 'custom',
}
